import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/how-to-participate',
		name: 'how-to-participate',
		component: () => import(/* webpackChunkName: "how-to-participate" */ '../views/HowToParticipate.vue'),
	},
	{
		path: '/prizes',
		name: 'prizes',
		component: () => import(/* webpackChunkName: "prizes" */ '../views/Prizes.vue'),
	},
	{
		path: '/terms',
		name: 'terms',
		component: () => import(/* webpackChunkName: "terms" */ '../views/Terms.vue'),
	},
	{
		path: '/terms',
		name: 'terms',
		component: () => import(/* webpackChunkName: "terms" */ '../views/Terms.vue'),
	},
	{
		path: '/about',
		name: 'about',
		component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
